var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('div',{staticClass:"deco-line d-none d-sm-none d-md-block"})])}
var staticRenderFns = []

export { render, staticRenderFns }